import React, { Component } from 'react';
import './index.scss';
import lanmarkImg from '../../assets/images/landmark-extra-icon.svg';
import barCode from '../../assets/images/bar-code-icon.svg';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { ReactComponent as IconHome } from '../../assets/images/icons/iconHome.svg';
const isConfirmationPage = window.location.pathname === '/confirmation';

const CustomBanner = ({ titleLogo, title, subtitle, onBackBtnClick, renderAsHtml, rewardsRedeemText, voucherTitle, customClassName, onHomeBtnClick }) => {
  var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
  return (
    <section className="custom-banner" style={{ background: 'url(/assets/images/bg-pattern.svg) var(--login-custom-banner-color) no-repeat' }}>
      <div className="header">
        {onBackBtnClick ? (
          <button onClick={onBackBtnClick}>
            <KeyboardArrowLeft sx={{ color: 'var(--login-page-back-arrow-color)' }} />
            <span>BACK</span>
          </button>
        ) : onHomeBtnClick ? (
          <div className="top-header">
            <aside className="siteLogo">
              <img src={'/assets/images/logo.svg'} alt="Cinemas" className="img-fluid" width={window.constant.LOGO_WIDTH} height={window.constant.LOGO_HEIGHT} />
            </aside>
            <aside className={`home-icon ${isConfirmationPage ? 'guest' : ''}`}>
              <Link to={`/?cinemaid=${getCinemaIdFromLocalstorage}`} className="homeButton" title="Go Home">
                <IconHome className="img-fluid" />
                <span>Go Home</span>
              </Link>
            </aside>
          </div>
        ) : (
          <Link to={-1}>BACK</Link>
        )}
      </div>
      <div className="content">
        {voucherTitle ? <h3>{voucherTitle}</h3> : ''}
        {titleLogo != '' ? <img src={titleLogo} className="img-fluid" /> : ''}
        {title ? <h1>{title}</h1> : ''}
        {/* <span>{subtitle}</span> */}
        {renderAsHtml ? <span dangerouslySetInnerHTML={{ __html: subtitle }}></span> : <span>{subtitle}</span>}
        {rewardsRedeemText ? <p className="rewardsRedeemText">{rewardsRedeemText}</p> : ''}
      </div>
    </section>
  );
};

export default CustomBanner;
